import React, { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import BoxMedia from "../../items/fragments/BoxMedia.js";

const MediaQuestionBox = ({ item, match, onTagClick }) => {
    const { title } = item;
    const [pseudo, setPseudo] = useState("");
    const [question, setQuestion] = useState("");

    return (
      <BoxMedia media={item} match={match} onTagClick={onTagClick}>
        <Typography variant="mediaH2" component="div" sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
        }}>
          {title}
        </Typography>

        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="Pseudo"
            variant="outlined"
            value={pseudo}
            onChange={(e) => setPseudo(e.target.value)}
            disabled
          />
          <TextField
            label="Votre question"
            variant="outlined"
            multiline
            rows={3}
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            disabled
          />
          <Button variant="contained" disabled>Envoyer ma question</Button>
        </Box>
      </BoxMedia>
    );
};

export default MediaQuestionBox;